import EmbossInfoAccessDialog from './EmbossInfoAccessDialog';

export default EmbossInfoAccessDialog;